import styled from 'styled-components';

export const ButtonTransparent = styled.div`
  button {
    background: transparent;
    border: none;
  }
`;
